import { line as d3Line } from 'd3-shape';
import { IChannel, ISample } from '../models/ichannel';
import { ECG_CONSTANTS } from '../utils/ecg-constants';
import { Scaler } from '../utils/scaler';
import { ILayout } from '../models/interfaces';
import { TraceData } from './trace-data';
import { TraceViewModel } from './trace-viewmodel';

export class ReferenceTraceViewModel extends TraceViewModel {
    // constructor

    constructor(layout: ILayout, channel: IChannel) {
        let traceData = new TraceData();
        traceData.originalChannel = channel;
        traceData.derivedChannel = channel;

        super(layout as ILayout, traceData);

        if (this.step) this.step.title = 'Reference ' + channel.name;
    }

    // public functions

    updateTraceTimeAlignment(_: { start: number; end: number }) {
        this._windowedSamples = this.channel?.samples ?? [];
        this.updateTrace();
    }

    // protected functions

    protected updateScale() {
        const leadWidth = this.layout?.context?.leadWidth ?? 0;
        const leadHeight = this.layout?.context?.leadHeight ?? 0;
        const scaleSettingsX = {
            domain: { min: 0, max: this.windowedSamples.length },
            range: { min: 0, max: 4 * leadWidth },
        };
        const scaleSettingsY = {
            domain: {
                min: -ECG_CONSTANTS.MAX_POSITIVE_MICROVOLT_VALUE,
                max: ECG_CONSTANTS.MAX_POSITIVE_MICROVOLT_VALUE,
            },
            range: { min: leadHeight, max: 0 },
        };
        this.scaler = new Scaler(scaleSettingsX, scaleSettingsY);
        const scaler = this.scaler;
        let line = d3Line<ISample>()
            .x((_sample: ISample, index) => {
                return scaler.onX(index);
            })
            .y((sample: ISample) => {
                return scaler.onY(sample.value);
            });

        return line;
    }
}
